import type { AsyncThunkAction } from "@reduxjs/toolkit";

type AsyncThunkConfig = {
	state: unknown;
	getState(): unknown;
};

export const rejectOnUndefined = <T>(payload: T) => {
	return payload ? Promise.resolve(payload) : Promise.reject();
};

export const testAsyncAction = <AppState, Returned, ThunkArg>(
	actionCreator: AsyncThunkAction<Returned, ThunkArg, AsyncThunkConfig>, getState: () => AppState
) => {
	actionCreator(jest.fn(), getState, undefined)
		.then(payload => {
			payload.meta.requestId = "";

			expect(payload).toMatchSnapshot();
		});
};
